"use client"
import { useLanguage } from "../contexts/LanguageContext"
import { motion } from "framer-motion"

const Hero = () => {
  const { t } = useLanguage()

  // הפונקציה הועברה לקומפוננטת FloatingWhatsApp

  return (
    <motion.section 
      id="home" 
      className="hero"
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8 }}
      aria-label="Gold House - דירות יוקרה להשכרה לטווח קצר"
    >
      <div className="hero-background">
        <motion.img 
          src="https://res.cloudinary.com/dp3vi9xno/image/upload/v1752569955/Hero_Back_i3joic.png" 
          alt="דירות יוקרה להשכרה - Gold House" 
          className="hero-image" 
          initial={{ scale: 1.05 }}
          animate={{ 
            scale: 1.15,
            x: [0, 10, 0, -10, 0],
            y: [0, -10, 0, 10, 0]
          }}
          transition={{ 
            scale: { duration: 8, repeat: Infinity, repeatType: "reverse" },
            x: { duration: 5, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" },
            y: { duration: 6, repeat: Infinity, repeatType: "mirror", ease: "easeInOut" }
          }}
        />
        <div className="hero-overlay"></div>
      </div>
      {/* <div className="hero-background">
        <video src="https://res.cloudinary.com/dp3vi9xno/video/upload/v1756714647/Hero_Back_video_kylv0h.mp4" alt="Luxury apartment interior" className="hero-image" autoPlay loop muted />
        <div className="hero-overlay"></div>
      </div> */}

      <div className="container">
        <div className="hero-content">
          <motion.h1 
            className="hero-title"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
            itemProp="name"
          >
            {t("heroTitle")}
          </motion.h1>
          <motion.p 
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.4 }}
          >
            {t("heroSubtitle")}
          </motion.p>
        </div>
      </div>
    </motion.section>
  )
}

export default Hero
